<template>
    <span class="copy-to-clipboard" @click="({ currentTarget }) => copyToClipboard(currentTarget as HTMLElement)">
        <div class="tooltip">
            <span class="copy">{{ t('widget.clipboard.copy') }}</span>
            <span class="copied">{{ t('widget.clipboard.copied') }}</span>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="icon-copy">
            <path
                d="M17.25 2.9H12.75C10.627 2.9 8.9 4.62702 8.9 6.75V11.25C8.9 13.373 10.627 15.1 12.75 15.1H17.25C19.373 15.1 21.1 13.373 21.1 11.25V6.75C21.1 4.62702 19.373 2.9 17.25 2.9ZM19.4 11.25C19.4 12.4353 18.4353 13.4 17.25 13.4H12.75C11.5647 13.4 10.6 12.4353 10.6 11.25V6.75C10.6 5.56473 11.5647 4.6 12.75 4.6H17.25C18.4353 4.6 19.4 5.56473 19.4 6.75V11.25ZM11.25 21.1C13.373 21.1 15.1 19.373 15.1 17.25C15.1 16.7808 14.72 16.4 14.25 16.4C13.78 16.4 13.4 16.7808 13.4 17.25C13.4 18.4353 12.4353 19.4 11.25 19.4H6.75C5.56473 19.4 4.6 18.4353 4.6 17.25V12.75C4.6 11.5647 5.56473 10.6 6.75 10.6C7.22004 10.6 7.6 10.2192 7.6 9.75C7.6 9.28084 7.22004 8.9 6.75 8.9C4.62702 8.9 2.9 10.627 2.9 12.75V17.25C2.9 19.373 4.62702 21.1 6.75 21.1H11.25Z"
                fill="var(--text-color-light)"
                stroke="var(--text-color-light)"
                stroke-width="0.2"
            ></path>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="icon-copied">
            <path
                d="M17.25 15H12.75C10.6823 15 9 13.3177 9 11.25V6.75C9 4.68225 10.6823 3 12.75 3H17.25C19.3177 3 21 4.68225 21 6.75V11.25C21 13.3177 19.3177 15 17.25 15ZM11.25 21H6.75C4.68225 21 3 19.3177 3 17.25V12.75C3 10.6823 4.68225 9 6.75 9C7.16475 9 7.5 9.336 7.5 9.75V11.25C7.5 14.145 9.85575 16.5 12.75 16.5H14.25C14.6648 16.5 15 16.836 15 17.25C15 19.3177 13.3177 21 11.25 21Z"
                fill="var(--btcdirect-blue)"
            ></path>
        </svg>
    </span>
</template>

<script lang="ts" setup>
import { useTranslations } from '@btcdirect/composables';
import { useClipboard } from '@btcdirect/shared/src/composables/util/clipboard';

const props = defineProps({
    value: {
        type: String,
        required: true
    }
});

const { t } = useTranslations();
const { copy } = useClipboard();

const copyToClipboard = (currentTarget: HTMLElement): void => {
    currentTarget.classList.add('clicked');

    copy(props.value);

    setTimeout(() => {
        currentTarget.classList.remove('clicked');
    }, 500);
};
</script>

<style lang="scss" scoped>
@use '@@scss/flex';

.copy-to-clipboard {
    @include flex.flex;
    @include flex.align(center, center);
    position: relative;

    .tooltip {
        visibility: hidden;
        background-color: var(--copy-tooltip-background-color);
        color: white;
        border: 1px solid var(--copy-tooltip-border-color);
        text-align: center;
        border-radius: 0.375rem;
        padding: 0.375rem 0.75rem;
        position: absolute;
        right: 0;
        z-index: 1;
        bottom: 2rem;

        &::after {
            content: '';
            position: absolute;
            top: 100%;
            right: 0.375rem;
            border-width: 0.375rem;
            border-style: solid;
            border-color: var(--copy-tooltip-border-color) transparent transparent transparent;
        }

        .copied {
            display: none;
        }
    }

    svg {
        height: 1.5em;
        width: 1.5em;
        transition: color 0.2s ease-in-out;

        &.icon-copied {
            display: none;
        }
    }

    &:hover {
        cursor: pointer;

        .tooltip {
            visibility: visible;
        }
    }

    &.clicked {
        .tooltip {
            .copy {
                display: none;
            }

            .copied {
                display: block;
            }
        }

        svg {
            &.icon-copy {
                display: none;
            }

            &.icon-copied {
                display: block;
            }
        }
    }
}
</style>
